const Profile = () => {
    return(
        <div className="text-white"><h1>HI</h1></div>
    )
}

export default Profile;